import './styles.css';

import { ScrollColumnView } from '@ipfabric/ui-components/ScrollView/ScrollColumnView';
import type { MulticastFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/MulticastFormValues';
import type { FormikProps } from 'formik';
import { type FC, useState } from 'react';
import { GraphMulticastForm } from './GraphMulticastForm';
import { PathCheck } from './PathCheck';
import { getPathLookupMulticastFromLocalStorage } from './PathLookupLocalStorage';
import type { Vrf } from './fetchVrf';
import { useGraphPathlookupForm } from './useGraphPathlookupForm';

interface Props {
  resetAdvancedOptionsToSelectedPreset: () => void;
  formik: FormikProps<MulticastFormValues>;
}

export const GraphMulticast: FC<Props> = (props) => {
  const [vrf, setVrf] = useState<Vrf[]>([]);

  const localStoragePathlookupMulticast =
    getPathLookupMulticastFromLocalStorage();

  const { handleProtocolChange } = useGraphPathlookupForm({
    loadedFromLocalStorage: localStoragePathlookupMulticast !== null,
    updateFieldValue: props.formik.setFieldValue,
    updateVrf: setVrf,
    vrf,
    vrfValue: props.formik.values.vrf,
    vrfIpError: props.formik.errors.source,
    vrfIpValue: props.formik.values.source,
  });

  return (
    <ScrollColumnView className='graph-pathlookup__content'>
      <GraphMulticastForm
        resetAdvancedOptionsToSelectedPreset={
          props.resetAdvancedOptionsToSelectedPreset
        }
        formik={props.formik}
        onProtocolChange={handleProtocolChange}
        vrf={vrf}
      />
      <PathCheck type='multicast' />
    </ScrollColumnView>
  );
};
